<template>
  <main>
    <div class="container-fluid classe-detail">
      <div class="row bloc">
        <div class="col-md-12 top-wrapper">
          <TopTemplate>
            <template v-slot:left-element>
              <router-link :to="{name: 'ClasseList'}" class="btn btn-outline-primary button button-left" :disabled="loading">
                <i class="arrow left"></i>
                {{ $t("button.retour") }}
              </router-link>
            </template>

            <template v-if="statusSchoolYear" v-slot:right-element>
              <div class="d-flex buttons-wrapper button-right">
                <router-link :to="{name: 'EditClasse', params: {id: referenceId}}" class="btn button btn-primary" :disabled="loading">
                  <i class="icon-edit-03"></i>
                  {{ $t("button.edit") }}
                </router-link>
                <a @click.prevent="deleteClass(referenceId)" class="btn btn-outline-primary button" :disabled="loading">
                  <i class="icon-trash"></i>
                  {{ $t("button.delete") }}
                </a>
              </div>
            </template>
          </TopTemplate>
        </div>
      </div>

      <div class="ajout-container row bloc">
        <div class="col-md-6 col-12 select-wrapper bloc-title">
          <div>
            <span class="title-select"
              ><b> {{ $t("classe.form.niveaux") }} </b>{{ reference.type }}</span
            >
          </div>
        </div>
        <div class="col-md-6 col-12 select-wrapper">
          <span class="title-select"
            ><b>{{ $t("classe.form.class") }} </b>{{ reference.name }}</span
          >
        </div>
      </div>
      <div class="general-info-class classes_blocs stat row first-row justify-content-center">
        <div class="col-md-4 select-wrapper paragraph bloc-title">
          <div>
            <i class="icon-graduation-hat"></i>
          </div>
          <div>
            <h3 class="mat">{{ reference.nb_students }}</h3>
            <!-- <hr/> -->
            <p>{{ $t("barStatic.students") }}</p>
          </div>
        </div>
        <div class="col-md-4 select-wrapper bloc-title">
          <div>
            <i class="icon-book-open"></i>
          </div>
          <div>
            <h3 class="mat">{{ reference.nb_courses }}</h3>
            <p class="matiere">{{ $t("barStatic.courses") }}</p>
          </div>
        </div>
        <div class="col-md-4 select-wrapper bloc-title">
          <div>
            <i class="icon-teacher"></i>
          </div>
          <div>
            <h3 class="mat">{{ reference.nb_teachers }}</h3>
            <p class="enseignant">{{ $t("barStatic.teachers") }}</p>
          </div>
        </div>
      </div>

      <div class="row">
        <b-tabs content-class="mt-3">
          <b-tab title="Élèves" active>
            <div class="table card text-center d-block pt-2 pb-2" v-if="reference.nb_students === 0">
              <span>{{ $t("common.emptysearshStudent") }}</span>
            </div>
            <div class="table" v-else>
              <div class="search-date-wrapper search-filter-wrapper bordered" :class="showFil === false ? 'borderNan' : ''">
                <div class="searchT searchTeacher">
                  <input v-model="paramsStudent.q" type="text" placeholder="Recherche" name="search" @input="searshStudent()" />
                  <img src="../../assets/icons/search-icon.svg" class="icon-search" alt="search" />
                </div>
              </div>
              <div v-if="loading" class="card mt-4 text-center d-block pt-4 pb-4">
                <div class="spinner-border text-info" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
              <div class="container-fluid empty-message">
                <div class="col-md-12">
                  <div v-if="!loading && students.length == 0" class="card mt-4">
                    <div class="col-12 empty-result text-center pt-3">
                      <p>{{ $t("common.emptysearshStudent") }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="table eleve" v-if="!loading && students.length > 0">
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="table__wrapper table-responsive-vertical table-responsive">
                        <table class="table__classes">
                          <thead>
                            <tr class="item_class">
                              <th>{{ $t("eleve.tab.name") }}</th>
                              <th>{{ $t("eleve.tab.dateNaissane") }}</th>
                              <th>{{ $t("eleve.tab.father") }}</th>
                              <th>{{ $t("eleve.tab.mother") }}</th>
                              <!--  <th>Coordonnées</th> -->
                              <th class="action">{{ $t("common.actions") }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr class="item_class" v-for="student in students" :key="student.id">
                              <td>
                                <router-link
                                  class="success_msg name_propre"
                                  :to="{
                                    name: 'DetailStudent',
                                    params: {id: student.id},
                                  }"
                                  >{{ student.first_name }} {{ student.last_name }}</router-link
                                >
                              </td>
                              <td>
                                <span v-if="student.birthday">
                                  {{ formatDateFR(student.birthday) }}
                                </span>
                                <span v-else>__</span>
                              </td>
                              <td>
                                <div v-if="student.parents.length > 0">
                                  <div v-for="(parent, index) in student.parents" :key="index">
                                    <span v-if="parent.gender === 0" class="name_propre" style="padding-right: 4px">{{ parent.last_name }} {{ parent.first_name }}</span>
                                    <span v-if="student.parents.length === 1 && parent.gender !== 0">__</span>
                                  </div>
                                </div>
                                <div v-else>__</div>
                              </td>
                              <td>
                                <div v-if="student.parents.length > 0">
                                  <div v-for="(parent, index) in student.parents" :key="index">
                                    <span v-if="parent.gender === 1" class="name_propre" style="padding-right: 4px">{{ parent.last_name }} {{ parent.first_name }}</span>
                                    <span v-if="student.parents.length === 1 && parent.gender !== 1">__</span>
                                  </div>
                                </div>
                                <div v-else>__</div>
                              </td>
                              <!--  <td></td> -->
                              <td class="action">
                                <div style="height: 16px">
                                  <router-link
                                    :to="{
                                      name: 'DetailStudent',
                                      params: {id: student.id},
                                    }"
                                    class
                                  >
                                    <i class="icon-eyes">
                                      <span class="tooltiptext">{{ $t("button.tooltip.details") }}</span>
                                    </i>
                                  </router-link>

                                  <router-link
                                    v-if="statusSchoolYear"
                                    :to="{
                                      name: 'EditStudent',
                                      params: {id: student.id},
                                    }"
                                    class
                                  >
                                    <i class="icon-edit-02">
                                      <span class="tooltiptext">{{ $t("button.tooltip.update") }}</span>
                                    </i>
                                  </router-link>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div class="table__wrapper__pagination-wrapper">
                          <div class="pagination">
                            <pagination v-if="last_page_student > 1" :dataSet="paginationStudent" @goToPage="getResultsStudents" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>

          <b-tab title="Enseignants">
            <div v-if="reference.nb_teachers === 0" class="table card text-center d-block pt-2 pb-2">
              <span>{{ $t("common.emptysavetechear") }}</span>
            </div>
            <div class="table" v-else>
              <div class="search-date-wrapper search-filter-wrapper bordered" :class="showFil === false ? 'borderNan' : ''">
                <div class="searchT searchTeacher">
                  <input v-model="paramsTeacher.q" type="text" placeholder="Recherche" name="search" @input="searshTeacher()" />
                  <img src="../../assets/icons/search-icon.svg" class="icon-search" alt="search" />
                </div>
              </div>
              <div v-if="loading" class="card mt-4 text-center d-block pt-4 pb-4">
                <div class="spinner-border text-info" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
              <div class="container-fluid empty-message">
                <div class="col-md-12">
                  <div v-if="!loading && reference.nb_teachers == 0" class="card mt-4">
                    <div class="col-12 empty-result text-center pt-2 pb-2">
                      <p>{{ $t("common.emptysavetechear") }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="table teacher" v-if="!loading && teachers.length > 0">
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="table__wrapper table-responsive-vertical table-responsive">
                        <table>
                          <thead>
                            <tr>
                              <th class="enseignant">{{ $t("teacher.tab.name") }}</th>
                              <th>{{ $t("teacher.tab.course") }}</th>

                              <th class="actions">{{ $t("common.actions") }}</th>
                            </tr>
                          </thead>

                          <tbody>
                            <tr v-for="teacher in teachers" :key="teacher.id">
                              <td>
                                <router-link
                                  style="color: black; font-weight: 600"
                                  class="name_propre"
                                  :to="{
                                    name: 'DetailTeacher',
                                    params: {id: teacher.id},
                                  }"
                                >
                                  <span v-if="teacher.last_name"> {{ teacher.last_name }} </span>&nbsp;
                                  <span v-if="teacher.first_name">
                                    {{ teacher.first_name }}
                                  </span>
                                </router-link>
                              </td>

                              <td style="display: flex">
                                <div v-for="(course, index) in teacher.courses" :key="course.id">
                                  <span> {{ course.name }}<span v-if="index + 1 < teacher.courses.length">, &nbsp;</span> </span>
                                  <!-- {{ course.name }}
                                <span v-if="teacher.courses.length > 1">,</span> -->
                                </div>
                                <div v-if="teacher.courses.length === 0"><span> __ </span>&nbsp;</div>
                              </td>

                              <td class="action">
                                <div style="height: 16px">
                                  <router-link
                                    style="color: black; font-weight: 600"
                                    :to="{
                                      name: 'DetailTeacher',
                                      params: {id: teacher.id},
                                    }"
                                  >
                                    <i class="icon-eyes">
                                      <span class="tooltiptext">{{ $t("button.tooltip.details") }}</span>
                                    </i></router-link
                                  ><router-link
                                    v-if="statusSchoolYear"
                                    :to="{
                                      name: 'EditTeacher',
                                      params: {id: teacher.id},
                                    }"
                                    class
                                  >
                                    <i class="icon-edit-02">
                                      <span class="tooltiptext">{{ $t("button.tooltip.update") }}</span>
                                    </i>
                                  </router-link>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>

                        <div class="table__wrapper__pagination-wrapper">
                          <div class="pagination">
                            <pagination v-if="last_page_teacher > 1" :dataSet="paginationTeacher" @goToPage="getResultsTeachers" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>

          <b-tab title="Emploi du temps">
            <div class="row">
              <div class="col-md-12">
                <span v-if="referenceEmploi === null">{{ $t("common.noData") }}</span>
                <iframe v-else :src="referenceEmploi" scrolling="no" frameborder="0" width="100%" height="1120"></iframe>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </main>
</template>
<script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import ClasseService from "../../services/classe.service";
import StudentService from "../../services/student.service";
import pagination from "../../components/navigation/Pagination";
import moment from "moment";
import {mapGetters} from "vuex";
//import pdf from 'vue-pdf'
export default {
  name: "DetailsClasse",
  components: {
    TopTemplate,
    pagination,
  },

  data() {
    return {
      loading: false,
      paginationTeacher: {},
      paginationStudent: {},
      totalTeacher: 0,
      totalStudent: 0,
      last_page_teacher: null,
      last_page_student: null,
      classes: [],
      teachers: [],
      students: [],
      referenceId: null,
      reference: {},
      showFil: false,
      params: {
        q: "",
        limit: 10,
        page: 1,
        sort: "created_at",
        order: false,
        school_year: localStorage.getItem("school_year") || "",
      },
      paramsTeacher: {
        q: "",
        limit: 10,
        page: 1,
        sort: "full_name",
        order: true,
        school_year: "",
      },
      paramsStudent: {
        q: "",
        limit: 10,
        page: 1,
        sort: "first_name",
        order: true,
        school_year: "",
      },
      moment: null,
    };
  },
  created() {
    this.moment = moment;
    this.referenceId = parseInt(this.$route.params.id);
    if (this.getPassageYears && this.getPassageYears.id) {
      localStorage.setItem("school_year", this.getPassageYears.id);
    }
  },
  mounted() {
    this.getDetails();
  },
  computed: {
    ...mapGetters(["getPassageYears"]),
    statusSchoolYear() {
      return this.getPassageYears.status;
    },
    referenceEmploi() {
      return this.reference.timetable ? window.location.origin + this.reference.timetable + "#view=FitH" : null;
    },
  },

  methods: {
    searshTeacher: _.debounce(function () {
      if (this.paramsTeacher.q.toString().length > 1 || !this.paramsTeacher.q.toString().length) {
        this.paramsTeacher.hasfilter = true;
        this.getResultsTeachers();
      }
    }, 200),
    searshStudent: _.debounce(function () {
      if (this.paramsStudent.q.toString().length > 1 || !this.paramsStudent.q.toString().length) {
        this.paramsStudent.hasfilter = true;
        this.getResultsStudents();
      }
    }, 200),
    getDetails() {
      this.loading = true;
      if (this.referenceId) {
        ClasseService.get(this.referenceId)
          .then((response) => {
            this.reference = response.data.data;
            this.loading = false;
          })
          .catch((error) => {
            if (error.response && error.response.status === 404) {
              this.$router.push("/error-404");
            }
          });
        this.getResultsStudents();
        this.getResultsTeachers();
      }
    },

    deleteClass(id) {
      const Swal = require("sweetalert2");
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-confirm btn-primary",
          cancelButton: "btn btn-cancel btn-outline-primary",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: this.$t("common.confirmDeleteClass"),
          icon: "warning",
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: this.$t("common.deletIT"),
          cancelButtonText: this.$t("common.noCancel"),
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            ClasseService.delete(id)

              .then((response) => {
                if (response.status === 200) {
                  console.log("Statut 200, affiche Swal"); // Debug
                  swalWithBootstrapButtons.fire(this.$t("common.classDeleted"), "", "success");
                  this.$router.push({name: "ClasseList"});
                }
              })
              .catch((error) => {
                console.log("Erreur attrapée:", error); // Debug

                this.loading = false;
                if (error && error.response) {
                  if (error.response.status === 400) {
                    swalWithBootstrapButtons.fire({
                      title: "Suppression impossible!",
                      html: "Cette classe ne peut pas être supprimée car elle contient des élèves.",
                      icon: "error",
                    });
                  }
                }
              });
          }
        });
    },
    makePaginationTeacher(meta, links) {
      return {
        current_page: meta.current_page,
        last_page: meta.last_page,
        next_page_url: links.next,
        prev_page_url: links.prev,
      };
    },
    formatDateFR(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    makePaginationStudent(meta, links) {
      return {
        current_page: meta.current_page,
        last_page: meta.last_page,
        next_page_url: links.next,
        prev_page_url: links.prev,
      };
    },
    getResultsTeachers(page = null) {
      this.paramsTeacher.page = !page ? this.paramsTeacher.page : page;
      this.loading = true;

      ClasseService.getTeachers(this.referenceId, {
        params: {
          q: this.paramsTeacher.q,
          limit: this.paramsTeacher.limit,
          page: this.paramsTeacher.page,
          sort: this.paramsTeacher.sort,
          order: this.paramsTeacher.order,
          school_year: localStorage.getItem("school_year"),
        },
      }).then(
        (response) => {
          this.teachers = response.data.data;
          this.paginationTeacher = this.makePaginationTeacher(response.data.meta, response.data.links);
          this.totalTeacher = response.data.meta.total;
          (this.last_page_teacher = response.data.meta.last_page), (this.loading = false);
        },
        (error) => {
          this.loading = false;
        }
      );
    },
    getResultsStudents(page = null) {
      this.paramsStudent.page = !page ? this.paramsStudent.page : page;
      this.loading = true;
      ClasseService.getStudents(this.referenceId, {
        params: {
          q: this.paramsStudent.q,
          limit: this.paramsStudent.limit,
          page: this.paramsStudent.page,
          sort: this.paramsStudent.sort,
          order: this.paramsStudent.order,
          school_year: localStorage.getItem("school_year"),
        },
      }).then(
        (response) => {
          this.students = response.data.data;
          this.paginationStudent = this.makePaginationStudent(response.data.meta, response.data.links);
          this.totalStudent = response.data.meta.total;
          this.last_page_student = response.data.meta.last_page;
          this.loading = false;
        },
        (error) => {
          this.loading = false;
        }
      );
    },
  },
};
</script>
<style>
.eleve {
  cursor: auto;
}
</style>
